import React from 'react';

const DangerCircleIcon = () => {
  return (
    <div className="vbz-icon-beneficiaries" data-testid="danger-circle-container">
      <div className="vbz-icon-beneficiaries-danger-circle" data-testid="danger-circle-icon" />
    </div>
  );
};

export default DangerCircleIcon;
